"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var Sentry = _interopRequireWildcard(require("@sentry/browser"));
var _apolloAbsintheUploadLink = require("apollo-absinthe-upload-link");
var _apolloCacheInmemory = require("apollo-cache-inmemory");
var _apolloClient = require("apollo-client");
var _apolloLink = require("apollo-link");
var _apolloLinkContext = require("apollo-link-context");
var _apolloLinkError = require("apollo-link-error");
var _apolloUploadClient = require("apollo-upload-client");
require("isomorphic-fetch");
var _constants = require("../utils/constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var getCookieLoggedName = function getCookieLoggedName(environment) {
  switch (environment) {
    case 'pull_request':
      return 'staging_shared_cookie';
    case 'development':
      return 'development_shared_cookie';
    case 'staging':
      return 'staging_shared_cookie';
    default:
      return 'shared_cookie';
  }
};
var cleanCookies = function cleanCookies(environment) {
  var setCookie = function setCookie(env) {
    document.cookie = "".concat(getCookieLoggedName(env), "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.plurall.net");
  };
  if (environment) {
    setCookie(environment);
    return;
  }
  ;
  ['pull_request', 'development', 'staging', 'production'].map(function (env) {
    return setCookie(env);
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var defaultConfig = {
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only'
    }
  }
};
var graphqlClient = function graphqlClient(_ref, _ref2) {
  var accessToken = _ref.accessToken,
    graphqlURL = _ref.graphqlURL,
    applicationId = _ref.applicationId,
    apolloConfig = _ref.apolloConfig,
    skipOnNetworkErrorRedirect = _ref.skipOnNetworkErrorRedirect,
    skipAuthOnNetworkError = _ref.skipAuthOnNetworkError,
    useApolloUploadClient = _ref.useApolloUploadClient,
    environment = _ref.environment,
    _ref$useTokenValidati = _ref.useTokenValidation,
    useTokenValidation = _ref$useTokenValidati === void 0 ? true : _ref$useTokenValidati,
    xClientGraphql = _ref.xClientGraphql;
  var clientId = _ref2.clientId;
  var httpLink = !useApolloUploadClient ? (0, _apolloAbsintheUploadLink.createLink)({
    uri: graphqlURL
  }) : (0, _apolloUploadClient.createUploadLink)({
    uri: graphqlURL
  });
  var baseHeaders = {
    idApplication: applicationId
  };
  if (xClientGraphql) {
    baseHeaders['x-client'] = xClientGraphql;
  }
  var authHeaders = _objectSpread(_objectSpread({}, baseHeaders), {}, {
    Authorization: "Bearer ".concat(accessToken)
  });
  var clientHeaders = accessToken ? authHeaders : baseHeaders;
  var authLink = (0, _apolloLinkContext.setContext)(function (_, _ref3) {
    var headers = _ref3.headers;
    return {
      headers: _objectSpread(_objectSpread({}, headers), clientHeaders)
    };
  });
  var configSentryError = function configSentryError(_ref4) {
    var operation = _ref4.operation,
      graphQLErrors = _ref4.graphQLErrors,
      networkError = _ref4.networkError;
    return (
      // eslint-disable-next-line implicit-arrow-linebreak
      Sentry.withScope(function (scope) {
        scope.setTransactionName(operation.operationName);
        scope.setContext('apolloGraphQLOperation', {
          operationName: operation.operationName,
          variables: operation.variables,
          extensions: operation.extensions
        });
        if (graphQLErrors instanceof Array) {
          graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors.forEach(function (error) {
            Sentry.captureMessage(error.message, {
              level: 'error',
              fingerprint: ["".concat(error.message, " - ").concat(operation.operationName)],
              contexts: {
                apolloGraphQLError: {
                  error: error,
                  message: error.message,
                  extensions: error.extensions
                }
              }
            });
          });
        }
        if (networkError) {
          Sentry.captureMessage(networkError.message, {
            level: 'error',
            contexts: {
              apolloNetworkError: {
                error: networkError,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                extensions: networkError.extensions
              }
            }
          });
        }
      })
    );
  };
  var errorLink = (0, _apolloLinkError.onError)(function (_ref5) {
    var operation = _ref5.operation,
      graphQLErrors = _ref5.graphQLErrors,
      networkError = _ref5.networkError;
    configSentryError({
      operation: operation,
      graphQLErrors: graphQLErrors,
      networkError: networkError
    });
    if (networkError && 'statusCode' in networkError) {
      if (((networkError === null || networkError === void 0 ? void 0 : networkError.statusCode) === 401 || (networkError === null || networkError === void 0 ? void 0 : networkError.statusCode) === 403) && !skipAuthOnNetworkError) {
        if (!useTokenValidation) {
          return;
        }
        cleanCookies(environment);
        if (window.location.pathname === '/error') {
          return null;
        }
        return window.location.reload();
      }
      if (!skipOnNetworkErrorRedirect) {
        window.location.href = "/error?title=".concat(_constants.NETWORK_ERROR_TITLE, "&message=").concat(_constants.NETWORK_ERROR_MESSAGE, "&status=").concat(networkError.statusCode);
      }
    }
    return null;
  });
  var link = _apolloLink.ApolloLink.from([authLink, errorLink, httpLink]);
  return new _apolloClient.ApolloClient(_objectSpread(_objectSpread({
    link: link,
    cache: new _apolloCacheInmemory.InMemoryCache({
      addTypename: false
    })
  }, defaultConfig), apolloConfig));
};
var _default = graphqlClient;
exports.default = _default;